import React, { Component } from "react";
import { connect } from "react-redux";
import { Modal, Button } from "react-bootstrap";
import { Elements, StripeProvider } from "react-stripe-elements";
import firebase from "../../../../../redux/config/firebase";

import * as actions from "../../../../../redux/user/actions";

import {
  isCreatingCustomer,
  isCreatingSubscription,
  showIncorrectCouponError,
  showCouponSuccess,
} from "../../../../../redux/user";

import type User from "../../models/User";

import CheckoutForm from "../../../../../components/forms/checkout-form/CheckoutForm";

type Props = {
  user: ?User,
  isNewCustomer: boolean,
  onModalClose: () => void,
  createCustomer: (token: string, coupon: string) => void,
  updateCustomer: (token: string) => void,
  validateCoupon: (coupon: string) => void,
  showCouponSuccess: boolean,
};

type StateProps = {};

type State = {};

class CardModal extends Component {
  constructor(props: Props) {
    super(props);
  }

  render() {
    return (
      <StripeProvider apiKey={firebase.options_.stripeKey}>
        {this.props.isNewCustomer
          ? this.renderAddForm()
          : this.renderUpdateForm()}
      </StripeProvider>
    );
  }

  renderAddForm() {
    return (
      <Modal.Dialog>
        <Modal.Header>
          <Modal.Title>Subscribe</Modal.Title>
        </Modal.Header>
        <Elements>
          <CheckoutForm
            createCustomer={(token, coupon) =>
              this.props.createCustomer(token, coupon)
            }
            isNewCustomer={true}
            onModalClose={() => this.props.onModalClose()}
            showIncorrectCouponError={this.props.showIncorrectCouponError}
            showCouponSuccess={this.props.showCouponSuccess}
            validateCoupon={(coupon) => this.props.validateCoupon(coupon)}
            isCreatingCustomer={this.props.isCreatingCustomer}
            isCreatingSubscription={this.props.isCreatingSubscription}
          />
        </Elements>
      </Modal.Dialog>
    );
  }

  renderUpdateForm() {
    return (
      <Modal.Dialog>
        <Modal.Header>
          <Modal.Title>Update Card</Modal.Title>
        </Modal.Header>
        <Elements>
          <CheckoutForm
            updateCustomer={(token) => this.props.updateCustomer(token)}
            isNewCustomer={false}
            onModalClose={() => this.props.onModalClose()}
          />
        </Elements>
      </Modal.Dialog>
    );
  }
}

export default CardModal;



// WEBPACK FOOTER //
// ./src/views/user/components/modals/card-modal/CardModal.js